import * as types from '../constants/ActionTypes';

export const initialState = {
    isMenuOpen: false
};

export default function menu(state = initialState, action = {}) {
    switch (action.type) {
        case types.OPEN_MENU:
            return {
                ...state,
                isMenuOpen: !state.isMenuOpen
            };
        default:
            return state;
    }
}
